import { render, staticRenderFns } from "./view.vue?vue&type=template&id=faae3e3c"
import script from "./view.ts?vue&type=script&lang=js&external"
export * from "./view.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('faae3e3c')) {
      api.createRecord('faae3e3c', component.options)
    } else {
      api.reload('faae3e3c', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=faae3e3c", function () {
      api.rerender('faae3e3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/veterinario/view.vue"
export default component.exports